import { type CallLog } from '@/types/CallLog'

/**
 * Creates a new CallLog with default values
 */
export function createCallLog(data: Partial<CallLog> = {}): CallLog {
  const now = new Date()

  return {
    id: data.id || crypto.randomUUID(),
    personId: data.personId,
    organizationId: data.organizationId,
    timestamp: data.timestamp || now,
    direction: data.direction || 'outgoing',
    notes: data.notes || '',
    durationSeconds: data.durationSeconds,
    createdAt: data.createdAt || now,
    updatedAt: data.updatedAt || now,
    tags: data.tags || [],
  }
}
